module.exports = __webpack_public_path__ + "static/img/Aacteacher5.06f72cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Aacteacher5.png
// module id = eU7Z
// module chunks = 1